/**
 * @format
 */
const Documents = () => import('@/views/document/document-index-view.vue');
const DocumentDesign = () => import('@/views/document-design/document-design-view.vue');
const DocumentTemplates = () => import('@/views/document/template/document-templates-index.vue');
const DocumentSign = () => import('@/views/document-design/document-signing-view.vue');
const DocumentSignDisclosure = () =>
    import('@/views/document-design/document-sign-disclosure-view.vue');
const DelegationPage = () => import('@/views/document-design/delegation-page-view.vue');
const InvalidDocumentPage = () => import('@/views/document-design/invalid-document-page-view.vue');
const AllDonePage = () => import('@/views/document-design/all-done-view.vue');
const PartPlayedPage = () => import('@/views/document-design/part-played-view.vue');
const EmailEditor = () => import('@/views/document-design/email-edit-view.vue');
const DocumentOwnerView = () => import('@/views/document-view/document-owner-view.vue');

export default [
    {
        path: '/Emails/:documentId/Edit',
        name: 'EmailEdit',
        component: EmailEditor,
        meta: {
            isUiShown: false,
            type: 'client',
            pageClass: 'email-edit-page',
            pageTitle: 'Email Editor',
        },
    },
    {
        path: '/Documents/',
        name: 'DocumentsIndex',
        component: Documents,
        meta: {
            type: 'client',
            subtype: 'sales',
            isUiShown: true,
            pageClass: 'document-index-page',
            pageTitle: 'Documents',
        },
    },
    {
        path: '/Documents/:documentId/Design',
        name: 'DocumentDesign',
        component: DocumentDesign,
        meta: {
            subtype: 'document',
            isUiShown: false,
            pageClass: 'document-design-page',
            pageTitle: 'Documents & Quoting',
        },
    },
    {
        path: '/Document/:documentId/Preview',
        name: 'DocumentPreview',
        component: DocumentSign,
        props: true,
        meta: {
            subtype: 'document',
            isUiShown: false,
            pageClass: 'document-preview',
            pageTitle: 'Document Preview',
        },
    },
    {
        path: '/Document/Sign/:guid',
        name: 'DocumentSign',
        component: DocumentSign,
        meta: {
            subtype: 'document',
            isUiShown: false,
            pageClass: 'document-sign',
            pageTitle: 'Document Sign',
        },
    },
    {
        path: '/Document/:guid/Delegate',
        name: 'DelegationPage',
        component: DelegationPage,
        meta: {
            isUiShown: false,
            type: 'general',
            pageClass: 'delegation-page',
            pageTitle: 'Delegation Page',
        },
    },
    {
        path: '/Document/Sign/:guid/Disclosure',
        name: 'DocumentDisclosure',
        component: DocumentSignDisclosure,
        meta: {
            subtype: 'document',
            isUiShown: false,
            pageClass: 'sign-disclosure',
            pageTitle: 'Sign Disclosure',
        },
    },
    {
        path: '/Documents/Templates',
        name: 'DocumentsTemplates',
        component: DocumentTemplates,
        meta: {
            subtype: 'sales',
            isUiShown: true,
            pageClass: 'document-templates-page',
            pageTitle: 'Document Templates',
        },
    },
    {
        path: '/Documents/Templates/:documentTemplateId/Design',
        name: 'DocumentTemplateDesign',
        component: DocumentDesign,
        meta: {
            subtype: 'document',
            isUiShown: false,
            pageClass: 'document-template-design-page',
            pageTitle: 'Document Template Builder',
        },
    },
    {
        path: '/Document/Template/:documentTemplateId/Preview',
        name: 'DocumentTemplatePreview',
        component: DocumentSign,
        meta: {
            subtype: 'document',
            isUiShown: false,
            pageClass: 'document-template-preview-page',
            pageTitle: 'Document Template Preview',
        },
    },

    {
        path: '/Clients/:clientId/Emails/:documentId/Edit',
        name: 'ClientEmailEdit',
        component: EmailEditor,
        meta: {
            isUiShown: false,
            type: 'client',
            pageClass: 'email-edit-page',
            pageTitle: 'Email Editor',
        },
    },
    {
        path: '/Clients/:clientId/Documents',
        name: 'ClientsDocuments',
        component: Documents,
        meta: {
            type: 'client',
            subtype: 'sales',
            isUiShown: true,
            pageClass: 'document-index-page',
            pageTitle: 'Documents',
        },
    },
    {
        path: '/Clients/:clientId/Documents/:documentId/Design',
        name: 'ClientDocumentDesign',
        component: DocumentDesign,
        meta: {
            type: 'client',
            subtype: 'document',
            isUiShown: false,
            pageClass: 'document-design-page',
            pageTitle: 'Documents & Quoting',
        },
    },
    {
        path: '/Clients/:clientId/Document/:documentId/Preview',
        name: 'ClientDocumentPreview',
        component: DocumentSign,
        meta: {
            type: 'client',
            subtype: 'document',
            isUiShown: false,
            pageClass: 'document-preview',
            pageTitle: 'Document Preview',
        },
    },
    {
        path: '/Clients/:clientId/Documents/Templates',
        name: 'ClientDocumentTemplates',
        component: DocumentTemplates,
        meta: {
            type: 'client',
            subtype: 'sales',
            isUiShown: true,
            pageClass: 'document-templates-page',
            pageTitle: 'Document Templates',
        },
    },
    {
        path: '/Clients/:clientId/Documents/Templates/:documentTemplateId/Design',
        name: 'ClientDocumentTemplateDesign',
        component: DocumentDesign,
        meta: {
            type: 'client',
            subtype: 'document',
            isUiShown: false,
            pageClass: 'document-template-design-page',
            pageTitle: 'Document Template Builder',
        },
    },
    {
        path: '/Clients/:clientId/Document/Template/:documentTemplateId/Preview',
        name: 'ClientDocumentTemplatePreview',
        component: DocumentSign,
        meta: {
            type: 'client',
            subtype: 'document',
            isUiShown: false,
            pageClass: 'document-template-preview-page',
            pageTitle: 'Document Template Preview',
        },
    },

    {
        path: '/Agencies/:AngencyId/Document/Template/:documentTemplateId/Preview',
        name: 'AgencyDocumentTemplatePreview',
        component: DocumentSign,
        meta: {
            type: 'client',
            subtype: 'document',
            isUiShown: false,
            pageClass: 'document-template-preview-page',
            pageTitle: 'Document Template Preview',
        },
    },

    {
        path: '/Agencies/:agencyId/Emails/:documentId/Edit',
        name: 'AgencyEmailEdit',
        component: EmailEditor,
        meta: {
            isUiShown: false,
            type: 'general',
            pageClass: 'email-edit-page',
            pageTitle: 'Email Editor',
        },
    },
    {
        path: '/Agencies/:agencyId/Documents/Templates',
        name: 'AgencyDocumentTemplates',
        component: DocumentTemplates,
        meta: {
            subtype: 'sales',
            isUiShown: true,
            pageClass: 'document-templates-page',
            pageTitle: 'Document Templates',
        },
    },
    {
        path: '/Agencies/:agencyId/Documents/Templates/:documentTemplateId/Design',
        name: 'AgencyDocumentTemplatesDesign',
        component: DocumentDesign,
        meta: {
            subtype: 'documennt',
            isUiShown: false,
            pageClass: 'document-template-design-page',
            pageTitle: 'Document Template Builder',
        },
    },

    {
        path: '/Document/Invalid',
        name: 'InvalidDocumentPage',
        component: InvalidDocumentPage,
        props: true,
        meta: {
            isUiShown: false,
            type: 'general',
            pageClass: 'invalid-document-page',
            pageTitle: 'Invalid Document',
        },
    },
    {
        path: '/Document/:documentId/Details',
        name: 'DocumentDetails',
        component: DocumentOwnerView,
        props: true,
        meta: {
            subtype: 'document',
            isUiShown: false,
            pageClass: 'document-ownerview-page',
            pageTitle: 'Document Details',
        },
    },
    {
        path: '/Clients/:clientId/Document/:documentId/Details',
        name: 'ClientDocumentDetails',
        component: DocumentOwnerView,
        props: true,
        meta: {
            type: 'client',
            subtype: 'document',
            isUiShown: false,
            pageClass: 'document-overview-page',
            pageTitle: 'Document Details',
        },
    },
    {
        path: '/Document/:guid/AllDone',
        name: 'AllDoneDocumentPage',
        component: AllDonePage,
        meta: {
            isUiShown: false,
            type: 'general',
            pageClass: 'all-done-page',
            pageTitle: 'Document Completed',
        },
    },
    {
        path: '/Document/PartPlayed',
        name: 'PartPlayedDocumentPage',
        component: PartPlayedPage,
        meta: {
            isUiShown: false,
            type: 'general',
            pageClass: 'part-played-page',
            pageTitle: 'Part Played',
        },
    },
];
